export default __webpack_public_path__ + "static/media/cover-3d.e5f154ea.png";